export const getServiceIdFromLabel = (value: string, options: { label: string; value: string }[]): string => {
  const idObj = options.find((option: { label: string; value: string }) => option.label === value);
  return idObj?.value || '';
};
